<template>
  <rest-list-column
    :prop="prop"
    :title="title"
    :width="width"
    :min-width="minWidth"
    :formatter="formatter"
    :sortable="sortable"
    :filter-number="true"
  />
</template>

<script>
import RestListColumn from '@/common/components/rest/RestListColumn'
import { formatNumber } from '@/core/helpers'

export default {
  name: 'RestListColumnNumber',

  components: { RestListColumn },

  props: {
    prop: {
      type: String,
      required: true
    },

    title: {
      type: String,
      required: true
    },

    width: {
      type: Number,
      required: false
    },

    minWidth: {
      type: Number,
      required: false
    },

    sortable: {
      required: false
    },

    formatter: {
      type: Function,
      required: false,
      default: value => {
        return formatNumber(value) || '-'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListColumnNumber.vue